import LegalConsentOptions from '../constants/legalConsentOptions';
const getIsImplicityConsent = legalConsentOption => legalConsentOption === LegalConsentOptions.IMPLICIT_CONSENT;
export default getIsImplicityConsent;